import { render } from "./PasswordChanged.vue?vue&type=template&id=0cf4cc86"
import script from "./PasswordChanged.vue?vue&type=script&lang=js"
export * from "./PasswordChanged.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/site/authorization/modal/PasswordChanged.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cf4cc86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cf4cc86', __exports__)) {
    api.reload('0cf4cc86', __exports__)
  }
  
  module.hot.accept("./PasswordChanged.vue?vue&type=template&id=0cf4cc86", () => {
    api.rerender('0cf4cc86', render)
  })

}


export default __exports__